
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { getCookie, setCookie } from '../../utils/publish'
  @Component({ name: 'PanelHeader' })
export default class DashboardHeader extends Vue {
    @Prop() showTeacher: boolean
    @Prop() showSource: boolean
    @Prop() isGetTime: boolean
    time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
    instrumentTypes = []
    teacherType = []
    campusType = []
    instrumentArr = []
    teacherArr = []
    campusArr = []
    sourceList: any = []
    agesList: any = [
      {
        id: '1',
        value: '成人'
      },
      {
        id: '2',
        value: '儿童'
      },
      {
        id: '3',
        value: '学生'
      }
    ]
    ages: any = []
    source: any = []

    @Watch('isGetTime')
    getTime(newVal, oldVal) {
      if(newVal) {
        this.time = JSON.parse(getCookie('time'))
        this.dataChange()
      }
    }

    async getInstrumentType() { // 乐器类型
      const res = await UserModule.InstrumentType()
      this.instrumentArr = res.data.list
    }
    async getCustomerSource() { // 获取来源
      const res = await UserModule.customerSource()
      this.sourceList = res.data.list
    }

    async teacher() { // 教师列表
      const res = await UserModule.getTeacher()
      this.teacherArr = res.data.list
    }

    async campus() { // 校区
      const res = await UserModule.getSchool()
      this.campusArr = res.data.list
    }

    instrumentChange(val) {
      this.instrumentTypes = val
      setCookie('instrumentTypes', JSON.stringify(val), 1)
      this.dataChange()
    }
    schoolChange(val) {
      this.campusType = val
      setCookie('campusType', JSON.stringify(val), 1)
      this.dataChange()
    }
    teacherChange(val) {
      this.teacherType = val
      setCookie('teacherType', JSON.stringify(val), 1)
      this.dataChange()
    }
    changeTime(val) {
      const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
      this.time = [val[0], end]
      setCookie('time', JSON.stringify(this.time), 1)
      this.dataChange()
    }
    sourceChange(val) {
      this.source = val
      setCookie('source', JSON.stringify(val), 1)
      this.dataChange()
    }
    ageChange (val) {
      this.ages = val
      setCookie('ages', JSON.stringify(val), 1)
      this.dataChange()
    }

    dataChange() {
      this.$emit('select-change', {
        instrumentTypes: this.instrumentTypes,
        campusType: this.campusType,
        teacherType: this.teacherType,
        time: this.time,
        ages: this.ages,
        source: this.source
      })
    }

    mounted() {
      const end = gettimeEnd()
      const start = gettimeStart()
      function gettimeStart() {
        const nowdays = new Date()
        let year = nowdays.getFullYear()
        let month: any = nowdays.getMonth()
        if (month === 0) {
          month = 12
          year = year - 1
        }
        if (month < 10) {
          month = '0' + month
        }
        let firstDayOfPreMonth = year + '-' + month + '-' + '01'
        firstDayOfPreMonth = firstDayOfPreMonth.toString()
        const sjc = (Date.parse(<any>new Date(firstDayOfPreMonth)) - 8 * 60 * 60 * 1000)
        return new Date(sjc)
      }
      function gettimeEnd() {
        const nowdays = new Date()
        let year = nowdays.getFullYear()
        let month:any = nowdays.getMonth()
        if (month === 0) {
          month = 12
          year = year - 1
        }
        if (month < 10) {
          month = '0' + month
        }
        const lastDay = new Date(year, month, 0)
        let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
        lastDayOfPreMonth = lastDayOfPreMonth.toString()
        const sjc = (Date.parse(<any>new Date(lastDayOfPreMonth)) + 16 * 60 * 60 * 1000 - 1000)
        return new Date(sjc)
      }
      this.instrumentTypes = JSON.parse(getCookie('instrumentTypes'))
      this.teacherType = JSON.parse(getCookie('teacherType'))
      this.campusType = JSON.parse(getCookie('campusType'))
      this.source = JSON.parse(getCookie('source'))
      this.ages = JSON.parse(getCookie('ages'))
      if (getCookie('time') == '[]') {
        this.time = [start, end]
        setCookie('time', JSON.stringify(this.time), 1)
      } else {
        this.time = JSON.parse(getCookie('time'))
      }
      this.dataChange()
      this.getInstrumentType()
      this.teacher()
      this.campus()
      this.getCustomerSource()
    }
}
